import { PieChartOutlined } from "@ant-design/icons";
import { Card, Space } from "antd";
import { useEffect, useState } from "react";
import Chart from "react-apexcharts";

const CategoryDistribution = ({ data: mainData, height = 350, loading }) => {
    const [chartData, setChartData] = useState({
        series: [],
        labels: [],
    });

    const customTooltip = ({ series, seriesIndex, w }) => {
        const label = w.config.labels[seriesIndex];
        const value = series[seriesIndex];
        return `
            <div style="padding: 8px;">
                <strong>${label}</strong>: ${value}
            </div>
        `;
    };

    const chartOptions = {
        chart: {
            type: "donut",
            animations: {
                enabled: true,
                easing: "easeinout",
                speed: 500,
            },
        },
        labels: chartData.labels,
        tooltip: {
            custom: customTooltip,
        },
        legend: {
            position: "bottom",
            fontSize: "13px",
            itemMargin: {
                horizontal: 8,
            },
        },
        colors: [
            "#F97316",
            "#3B82F6",
            "#10B981",
            "#64748B",
            "#9C27B0",
            "#00ACC1",
            "#FF5722",
            "#8BC34A",
        ],
        stroke: {
            show: true,
            width: 2,
            colors: ["#fff"],
        },
        responsive: [
            {
                breakpoint: 480,
                options: {
                    chart: {
                        width: 250,
                    },
                    legend: {
                        fontSize: "10px",
                        itemMargin: { horizontal: 6, vertical: 4 },
                    },
                },
            },
        ],
    };

    useEffect(() => {
        if (mainData?.series?.length && mainData?.category?.length) {
            const cleanedSeries = mainData.series.map((v) => Math.abs(v));
            setChartData({
                series: cleanedSeries,
                labels: mainData.category,
            });
        }
    }, [mainData]);

    return (
        <Card
            title={
                <Space>
                    <PieChartOutlined style={{ color: "#43a047" }} />
                    <span style={{ fontWeight: 600 }}>Category Distribution</span>
                </Space>
            }
            styles={{
                header: { background: '#f5f5f5' },
                body: { padding: '24px' }
            }}
            style={{
                borderRadius: "12px",
                boxShadow: "0 4px 12px rgba(0,0,0,0.05)",
                border: "1px solid #f0f0f0",
                height: "100%",
                minHeight: height,
            }}
            loading={loading}
        >
            {!!chartData.series.length ? (
                <Chart
                    options={chartOptions}
                    series={chartData.series}
                    type="donut"
                    height={height}
                />
            ) : (
                <div style={{ textAlign: 'center', padding: '20px', color: '#999' }}>
                    No data available
                </div>)}
        </Card>
    );
};

export default CategoryDistribution;